<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { useConsentFormsQuery, useCreateConsentRecordMutation } from '@/composables/api/agreements'

const { mutate } = useCreateConsentRecordMutation()
const { status, formData, agreementData } = useConsentFormsQuery()

const isConsentOpen = ref(false)

const toggleModal = () => {
  isConsentOpen.value = !isConsentOpen.value
}
const agreeClick = (data: { form_id: string }) => {
  mutate(data)
  toggleModal()
}
const isNotAgreed = computed(() => {
  return status.value !== 'pending' && formData.value !== null && agreementData.value === null
})
watch(isNotAgreed, (newIsNotAgreed) => {
  if (newIsNotAgreed) {
    isConsentOpen.value = true
  } else {
    isConsentOpen.value = false
  }
})
</script>
<template>
  <b-modal v-model="isConsentOpen" :can-cancel="[]">
    <div v-if="formData" class="container">
      <div class="card p-3 pb-4 filter-card-modal">
        <iframe :src="formData.url" width="100%" height="875" class="mx-auto" title="ama-consent" />

        <b-button
          class="has-text-right mt-3"
          @click="
            agreeClick({
              form_id: formData.id
            })
          "
          >{{ $t('agree') }}</b-button
        >
      </div>
    </div>
  </b-modal>
</template>
